import { BasePortal } from './BasePortal';
import { FBInstantGame } from '@cardsjd/fbinstantgame';
import { Device } from '@cardsjd/device';

export class FacebookPortal extends BasePortal {
	name = 'FacebookPortal';
	fBInstantGame = null;
	device = null;

	//property settings
	autoLogin = true;
	hideSuggestions = true;
	hideReportBug = true
	//hideMoreGames = false (conditional inside getter)

	constructor(config) {
		super();
		this.fBInstantGame = new FBInstantGame(config);
		this.device = new Device();
	}
	get hideMoreGames() {
		//if on ios hide more games - because of apple policy
		const os = this.device.getOS();
		if (os === 'ios') return true;

		return false;
	}
	async init() {
		await this.fBInstantGame.initialize();
	}
	isAvailable() {

		return true;
	}
	async load() {
		const fbUserdata = await this.fBInstantGame.loadData();
		const fbProfile = await this.fBInstantGame.getProfile();
		const data = {};
		data.userdata = fbUserdata;
		data.user = fbProfile;
		return data;
	}
	async save(data, forceSave) {
		this.fBInstantGame.saveData(data, forceSave).catch(function () { });
	}
	gameStart() {
	}

	gameStop() {
	}

	loadStart() {
		//it is inside the data load fBInstantGame.initialize or fBInstantGame.loadData
	}

	loadStop() {
		//it is inside the data load fBInstantGame.initialize or fBInstantGame.loadData
	}
	async subscribeBot() {
		await this.fBInstantGame.subscribeBot();
	}
	createShortCut() {
		this.fBInstantGame.createShortcut();
	}
	async getInvite() {
		//returns {message,room}
		return this.fBInstantGame.getInvite();
	}
	async invite(userId, room) {
		return this.fBInstantGame.invitePlayer(userId, room);
	}
	async findAndInvite(userFrom, room) {
		return this.fBInstantGame.inviteSend(userFrom, room);
	}
	async getFriends() {
		const fbUsers = await this.fBInstantGame.getConnectedPlayersAsync();
		if (!fbUsers) return [];
		const friends = [];
		for (let i = 0; i < fbUsers.length; i++) {
			const fbUser = fbUsers[i];

			//Facebook only gaves the facebookid, no name or userid
			const facebookId = fbUser.getID();
			friends.push({ facebookId: facebookId });
		}
		return friends;
	}
	
}
